// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=.js"
// @generated from file grackle/grackle_types.proto (package grackle, syntax proto3)
/* eslint-disable */
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
/**
 * Describes the file grackle/grackle_types.proto.
 */
export const file_grackle_grackle_types = /*@__PURE__*/ fileDesc("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");
/**
 * Describes the message grackle.Empty.
 * Use `create(EmptySchema)` to create a new message.
 */
export const EmptySchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 0);
/**
 * Describes the message grackle.EnvironmentId.
 * Use `create(EnvironmentIdSchema)` to create a new message.
 */
export const EnvironmentIdSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 1);
/**
 * Describes the message grackle.SessionId.
 * Use `create(SessionIdSchema)` to create a new message.
 */
export const SessionIdSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 2);
/**
 * Describes the message grackle.KillAgentRequest.
 * Use `create(KillAgentRequestSchema)` to create a new message.
 */
export const KillAgentRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 3);
/**
 * Describes the message grackle.Environment.
 * Use `create(EnvironmentSchema)` to create a new message.
 */
export const EnvironmentSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 4);
/**
 * Describes the message grackle.EnvironmentList.
 * Use `create(EnvironmentListSchema)` to create a new message.
 */
export const EnvironmentListSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 5);
/**
 * Describes the message grackle.AddEnvironmentRequest.
 * Use `create(AddEnvironmentRequestSchema)` to create a new message.
 */
export const AddEnvironmentRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 6);
/**
 * Describes the message grackle.ProvisionEvent.
 * Use `create(ProvisionEventSchema)` to create a new message.
 */
export const ProvisionEventSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 7);
/**
 * Describes the message grackle.ProvisionEnvironmentRequest.
 * Use `create(ProvisionEnvironmentRequestSchema)` to create a new message.
 */
export const ProvisionEnvironmentRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 8);
/**
 * Describes the message grackle.UpdateEnvironmentRequest.
 * Use `create(UpdateEnvironmentRequestSchema)` to create a new message.
 */
export const UpdateEnvironmentRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 9);
/**
 * Describes the message grackle.GitHubAccount.
 * Use `create(GitHubAccountSchema)` to create a new message.
 */
export const GitHubAccountSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 10);
/**
 * Describes the message grackle.GitHubAccountList.
 * Use `create(GitHubAccountListSchema)` to create a new message.
 */
export const GitHubAccountListSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 11);
/**
 * Describes the message grackle.AddGitHubAccountRequest.
 * Use `create(AddGitHubAccountRequestSchema)` to create a new message.
 */
export const AddGitHubAccountRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 12);
/**
 * Describes the message grackle.UpdateGitHubAccountRequest.
 * Use `create(UpdateGitHubAccountRequestSchema)` to create a new message.
 */
export const UpdateGitHubAccountRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 13);
/**
 * Describes the message grackle.RemoveGitHubAccountRequest.
 * Use `create(RemoveGitHubAccountRequestSchema)` to create a new message.
 */
export const RemoveGitHubAccountRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 14);
/**
 * Describes the message grackle.ImportGitHubAccountsResponse.
 * Use `create(ImportGitHubAccountsResponseSchema)` to create a new message.
 */
export const ImportGitHubAccountsResponseSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 15);
/**
 * Describes the message grackle.Session.
 * Use `create(SessionSchema)` to create a new message.
 */
export const SessionSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 16);
/**
 * Describes the message grackle.SessionList.
 * Use `create(SessionListSchema)` to create a new message.
 */
export const SessionListSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 17);
/**
 * Describes the message grackle.SessionFilter.
 * Use `create(SessionFilterSchema)` to create a new message.
 */
export const SessionFilterSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 18);
/**
 * Describes the message grackle.ModelSelection.
 * Use `create(ModelSelectionSchema)` to create a new message.
 */
export const ModelSelectionSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 19);
/**
 * Describes the message grackle.SessionConfig.
 * Use `create(SessionConfigSchema)` to create a new message.
 */
export const SessionConfigSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 20);
/**
 * Describes the message grackle.SpawnRequest.
 * Use `create(SpawnRequestSchema)` to create a new message.
 */
export const SpawnRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 21);
/**
 * Describes the message grackle.ResumeRequest.
 * Use `create(ResumeRequestSchema)` to create a new message.
 */
export const ResumeRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 22);
/**
 * Describes the message grackle.InputMessage.
 * Use `create(InputMessageSchema)` to create a new message.
 */
export const InputMessageSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 23);
/**
 * Describes the message grackle.ProtectedResource.
 * Use `create(ProtectedResourceSchema)` to create a new message.
 */
export const ProtectedResourceSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 24);
/**
 * Describes the message grackle.ModelInfo.
 * Use `create(ModelInfoSchema)` to create a new message.
 */
export const ModelInfoSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 25);
/**
 * Describes the message grackle.RuntimeInfo.
 * Use `create(RuntimeInfoSchema)` to create a new message.
 */
export const RuntimeInfoSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 26);
/**
 * Describes the message grackle.ListRuntimesResponse.
 * Use `create(ListRuntimesResponseSchema)` to create a new message.
 */
export const ListRuntimesResponseSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 27);
/**
 * Describes the message grackle.WaitForPipeRequest.
 * Use `create(WaitForPipeRequestSchema)` to create a new message.
 */
export const WaitForPipeRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 28);
/**
 * Describes the message grackle.WaitForPipeResponse.
 * Use `create(WaitForPipeResponseSchema)` to create a new message.
 */
export const WaitForPipeResponseSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 29);
/**
 * Describes the message grackle.WriteToFdRequest.
 * Use `create(WriteToFdRequestSchema)` to create a new message.
 */
export const WriteToFdRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 30);
/**
 * Describes the message grackle.CloseFdRequest.
 * Use `create(CloseFdRequestSchema)` to create a new message.
 */
export const CloseFdRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 31);
/**
 * Describes the message grackle.CloseFdResponse.
 * Use `create(CloseFdResponseSchema)` to create a new message.
 */
export const CloseFdResponseSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 32);
/**
 * Describes the message grackle.SessionFds.
 * Use `create(SessionFdsSchema)` to create a new message.
 */
export const SessionFdsSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 33);
/**
 * Describes the message grackle.FdInfo.
 * Use `create(FdInfoSchema)` to create a new message.
 */
export const FdInfoSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 34);
/**
 * Describes the message grackle.CreateStreamRequest.
 * Use `create(CreateStreamRequestSchema)` to create a new message.
 */
export const CreateStreamRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 35);
/**
 * Describes the message grackle.CreateStreamResponse.
 * Use `create(CreateStreamResponseSchema)` to create a new message.
 */
export const CreateStreamResponseSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 36);
/**
 * Describes the message grackle.AttachStreamRequest.
 * Use `create(AttachStreamRequestSchema)` to create a new message.
 */
export const AttachStreamRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 37);
/**
 * Describes the message grackle.AttachStreamResponse.
 * Use `create(AttachStreamResponseSchema)` to create a new message.
 */
export const AttachStreamResponseSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 38);
/**
 * Describes the message grackle.StreamSubscriberInfo.
 * Use `create(StreamSubscriberInfoSchema)` to create a new message.
 */
export const StreamSubscriberInfoSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 39);
/**
 * Describes the message grackle.StreamInfo.
 * Use `create(StreamInfoSchema)` to create a new message.
 */
export const StreamInfoSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 40);
/**
 * Describes the message grackle.ListStreamsRequest.
 * Use `create(ListStreamsRequestSchema)` to create a new message.
 */
export const ListStreamsRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 41);
/**
 * Describes the message grackle.ListStreamsResponse.
 * Use `create(ListStreamsResponseSchema)` to create a new message.
 */
export const ListStreamsResponseSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 42);
/**
 * Describes the message grackle.OperatorCreateStreamRequest.
 * Use `create(OperatorCreateStreamRequestSchema)` to create a new message.
 */
export const OperatorCreateStreamRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 43);
/**
 * Describes the message grackle.OperatorCreateStreamResponse.
 * Use `create(OperatorCreateStreamResponseSchema)` to create a new message.
 */
export const OperatorCreateStreamResponseSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 44);
/**
 * Describes the message grackle.OperatorAttachTaskRequest.
 * Use `create(OperatorAttachTaskRequestSchema)` to create a new message.
 */
export const OperatorAttachTaskRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 45);
/**
 * Describes the message grackle.OperatorAttachTaskResponse.
 * Use `create(OperatorAttachTaskResponseSchema)` to create a new message.
 */
export const OperatorAttachTaskResponseSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 46);
/**
 * Describes the message grackle.OperatorDetachTaskRequest.
 * Use `create(OperatorDetachTaskRequestSchema)` to create a new message.
 */
export const OperatorDetachTaskRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 47);
/**
 * Describes the message grackle.OperatorDetachTaskResponse.
 * Use `create(OperatorDetachTaskResponseSchema)` to create a new message.
 */
export const OperatorDetachTaskResponseSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 48);
/**
 * Describes the message grackle.TaskAttachment.
 * Use `create(TaskAttachmentSchema)` to create a new message.
 */
export const TaskAttachmentSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 49);
/**
 * Describes the message grackle.ListTaskAttachmentsRequest.
 * Use `create(ListTaskAttachmentsRequestSchema)` to create a new message.
 */
export const ListTaskAttachmentsRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 50);
/**
 * Describes the message grackle.ListTaskAttachmentsResponse.
 * Use `create(ListTaskAttachmentsResponseSchema)` to create a new message.
 */
export const ListTaskAttachmentsResponseSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 51);
/**
 * Describes the message grackle.OperatorCloseStreamRequest.
 * Use `create(OperatorCloseStreamRequestSchema)` to create a new message.
 */
export const OperatorCloseStreamRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 52);
/**
 * Describes the message grackle.OperatorCloseStreamResponse.
 * Use `create(OperatorCloseStreamResponseSchema)` to create a new message.
 */
export const OperatorCloseStreamResponseSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 53);
/**
 * Describes the message grackle.SessionEvent.
 * Use `create(SessionEventSchema)` to create a new message.
 */
export const SessionEventSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 54);
/**
 * Describes the message grackle.SessionEventList.
 * Use `create(SessionEventListSchema)` to create a new message.
 */
export const SessionEventListSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 55);
/**
 * Describes the message grackle.TokenEntry.
 * Use `create(TokenEntrySchema)` to create a new message.
 */
export const TokenEntrySchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 56);
/**
 * Describes the message grackle.TokenList.
 * Use `create(TokenListSchema)` to create a new message.
 */
export const TokenListSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 57);
/**
 * Describes the message grackle.TokenInfo.
 * Use `create(TokenInfoSchema)` to create a new message.
 */
export const TokenInfoSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 58);
/**
 * Describes the message grackle.TokenName.
 * Use `create(TokenNameSchema)` to create a new message.
 */
export const TokenNameSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 59);
/**
 * Describes the message grackle.CredentialProviderConfig.
 * Use `create(CredentialProviderConfigSchema)` to create a new message.
 */
export const CredentialProviderConfigSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 60);
/**
 * Describes the message grackle.SetCredentialProviderRequest.
 * Use `create(SetCredentialProviderRequestSchema)` to create a new message.
 */
export const SetCredentialProviderRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 61);
/**
 * Describes the message grackle.Workspace.
 * Use `create(WorkspaceSchema)` to create a new message.
 */
export const WorkspaceSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 62);
/**
 * Describes the message grackle.WorkspaceList.
 * Use `create(WorkspaceListSchema)` to create a new message.
 */
export const WorkspaceListSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 63);
/**
 * Describes the message grackle.ListWorkspacesRequest.
 * Use `create(ListWorkspacesRequestSchema)` to create a new message.
 */
export const ListWorkspacesRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 64);
/**
 * Describes the message grackle.CreateWorkspaceRequest.
 * Use `create(CreateWorkspaceRequestSchema)` to create a new message.
 */
export const CreateWorkspaceRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 65);
/**
 * Describes the message grackle.UpdateWorkspaceRequest.
 * Use `create(UpdateWorkspaceRequestSchema)` to create a new message.
 */
export const UpdateWorkspaceRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 66);
/**
 * Describes the message grackle.WorkspaceId.
 * Use `create(WorkspaceIdSchema)` to create a new message.
 */
export const WorkspaceIdSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 67);
/**
 * Describes the message grackle.LinkEnvironmentRequest.
 * Use `create(LinkEnvironmentRequestSchema)` to create a new message.
 */
export const LinkEnvironmentRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 68);
/**
 * Describes the message grackle.UnlinkEnvironmentRequest.
 * Use `create(UnlinkEnvironmentRequestSchema)` to create a new message.
 */
export const UnlinkEnvironmentRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 69);
/**
 * Describes the message grackle.Task.
 * Use `create(TaskSchema)` to create a new message.
 */
export const TaskSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 70);
/**
 * Describes the message grackle.TaskList.
 * Use `create(TaskListSchema)` to create a new message.
 */
export const TaskListSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 71);
/**
 * Describes the message grackle.ListTasksRequest.
 * Use `create(ListTasksRequestSchema)` to create a new message.
 */
export const ListTasksRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 72);
/**
 * Describes the message grackle.SearchTasksRequest.
 * Use `create(SearchTasksRequestSchema)` to create a new message.
 */
export const SearchTasksRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 73);
/**
 * Describes the message grackle.SearchTaskResult.
 * Use `create(SearchTaskResultSchema)` to create a new message.
 */
export const SearchTaskResultSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 74);
/**
 * Describes the message grackle.SearchTasksResponse.
 * Use `create(SearchTasksResponseSchema)` to create a new message.
 */
export const SearchTasksResponseSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 75);
/**
 * Describes the message grackle.CreateTaskRequest.
 * Use `create(CreateTaskRequestSchema)` to create a new message.
 */
export const CreateTaskRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 76);
/**
 * Describes the message grackle.TaskId.
 * Use `create(TaskIdSchema)` to create a new message.
 */
export const TaskIdSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 77);
/**
 * Describes the message grackle.UpdateTaskRequest.
 * Use `create(UpdateTaskRequestSchema)` to create a new message.
 */
export const UpdateTaskRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 78);
/**
 * Describes the message grackle.StartTaskRequest.
 * Use `create(StartTaskRequestSchema)` to create a new message.
 */
export const StartTaskRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 79);
/**
 * Describes the message grackle.SetWorkpadRequest.
 * Use `create(SetWorkpadRequestSchema)` to create a new message.
 */
export const SetWorkpadRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 80);
/**
 * Describes the message grackle.Component.
 * Use `create(ComponentSchema)` to create a new message.
 */
export const ComponentSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 81);
/**
 * Describes the message grackle.ComponentList.
 * Use `create(ComponentListSchema)` to create a new message.
 */
export const ComponentListSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 82);
/**
 * Describes the message grackle.RegisterComponentRequest.
 * Use `create(RegisterComponentRequestSchema)` to create a new message.
 */
export const RegisterComponentRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 83);
/**
 * Describes the message grackle.UpdateComponentRequest.
 * Use `create(UpdateComponentRequestSchema)` to create a new message.
 */
export const UpdateComponentRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 84);
/**
 * Describes the message grackle.GetComponentRequest.
 * Use `create(GetComponentRequestSchema)` to create a new message.
 */
export const GetComponentRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 85);
/**
 * Describes the message grackle.ListComponentsRequest.
 * Use `create(ListComponentsRequestSchema)` to create a new message.
 */
export const ListComponentsRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 86);
/**
 * Describes the message grackle.SearchComponentsRequest.
 * Use `create(SearchComponentsRequestSchema)` to create a new message.
 */
export const SearchComponentsRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 87);
/**
 * Describes the message grackle.SearchComponentResult.
 * Use `create(SearchComponentResultSchema)` to create a new message.
 */
export const SearchComponentResultSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 88);
/**
 * Describes the message grackle.SearchComponentsResponse.
 * Use `create(SearchComponentsResponseSchema)` to create a new message.
 */
export const SearchComponentsResponseSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 89);
/**
 * Describes the message grackle.SetComponentPromotionRequest.
 * Use `create(SetComponentPromotionRequestSchema)` to create a new message.
 */
export const SetComponentPromotionRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 90);
/**
 * Describes the message grackle.ResolveComponentGraphRequest.
 * Use `create(ResolveComponentGraphRequestSchema)` to create a new message.
 */
export const ResolveComponentGraphRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 91);
/**
 * Describes the message grackle.ResolveComponentGraphResponse.
 * Use `create(ResolveComponentGraphResponseSchema)` to create a new message.
 */
export const ResolveComponentGraphResponseSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 92);
/**
 * Describes the message grackle.Escalation.
 * Use `create(EscalationSchema)` to create a new message.
 */
export const EscalationSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 93);
/**
 * Describes the message grackle.EscalationList.
 * Use `create(EscalationListSchema)` to create a new message.
 */
export const EscalationListSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 94);
/**
 * Describes the message grackle.CreateEscalationRequest.
 * Use `create(CreateEscalationRequestSchema)` to create a new message.
 */
export const CreateEscalationRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 95);
/**
 * Describes the message grackle.ListEscalationsRequest.
 * Use `create(ListEscalationsRequestSchema)` to create a new message.
 */
export const ListEscalationsRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 96);
/**
 * Describes the message grackle.AcknowledgeEscalationRequest.
 * Use `create(AcknowledgeEscalationRequestSchema)` to create a new message.
 */
export const AcknowledgeEscalationRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 97);
/**
 * Describes the message grackle.ExposeChannelRequest.
 * Use `create(ExposeChannelRequestSchema)` to create a new message.
 */
export const ExposeChannelRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 98);
/**
 * Describes the message grackle.ExposeChannelResponse.
 * Use `create(ExposeChannelResponseSchema)` to create a new message.
 */
export const ExposeChannelResponseSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 99);
/**
 * Describes the message grackle.ChannelGrant.
 * Use `create(ChannelGrantSchema)` to create a new message.
 */
export const ChannelGrantSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 100);
/**
 * Describes the message grackle.ChannelGrantList.
 * Use `create(ChannelGrantListSchema)` to create a new message.
 */
export const ChannelGrantListSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 101);
/**
 * Describes the message grackle.ListChannelGrantsRequest.
 * Use `create(ListChannelGrantsRequestSchema)` to create a new message.
 */
export const ListChannelGrantsRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 102);
/**
 * Describes the message grackle.RevokeChannelGrantRequest.
 * Use `create(RevokeChannelGrantRequestSchema)` to create a new message.
 */
export const RevokeChannelGrantRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 103);
/**
 * Describes the message grackle.McpServerConfig.
 * Use `create(McpServerConfigSchema)` to create a new message.
 */
export const McpServerConfigSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 104);
/**
 * Describes the message grackle.ToolConfig.
 * Use `create(ToolConfigSchema)` to create a new message.
 */
export const ToolConfigSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 105);
/**
 * Describes the message grackle.AllowedMcpTools.
 * Use `create(AllowedMcpToolsSchema)` to create a new message.
 */
export const AllowedMcpToolsSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 106);
/**
 * Describes the message grackle.Persona.
 * Use `create(PersonaSchema)` to create a new message.
 */
export const PersonaSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 107);
/**
 * Describes the message grackle.PersonaList.
 * Use `create(PersonaListSchema)` to create a new message.
 */
export const PersonaListSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 108);
/**
 * Describes the message grackle.PersonaId.
 * Use `create(PersonaIdSchema)` to create a new message.
 */
export const PersonaIdSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 109);
/**
 * Describes the message grackle.CreatePersonaRequest.
 * Use `create(CreatePersonaRequestSchema)` to create a new message.
 */
export const CreatePersonaRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 110);
/**
 * Describes the message grackle.UpdatePersonaRequest.
 * Use `create(UpdatePersonaRequestSchema)` to create a new message.
 */
export const UpdatePersonaRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 111);
/**
 * Describes the message grackle.Agent.
 * Use `create(AgentSchema)` to create a new message.
 */
export const AgentSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 112);
/**
 * Describes the message grackle.AgentList.
 * Use `create(AgentListSchema)` to create a new message.
 */
export const AgentListSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 113);
/**
 * Describes the message grackle.AgentId.
 * Use `create(AgentIdSchema)` to create a new message.
 */
export const AgentIdSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 114);
/**
 * Describes the message grackle.CreateAgentRequest.
 * Use `create(CreateAgentRequestSchema)` to create a new message.
 */
export const CreateAgentRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 115);
/**
 * Describes the message grackle.UpdateAgentRequest.
 * Use `create(UpdateAgentRequestSchema)` to create a new message.
 */
export const UpdateAgentRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 116);
/**
 * Describes the message grackle.SetAgentHeartbeatRequest.
 * Use `create(SetAgentHeartbeatRequestSchema)` to create a new message.
 */
export const SetAgentHeartbeatRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 117);
/**
 * Describes the message grackle.Schedule.
 * Use `create(ScheduleSchema)` to create a new message.
 */
export const ScheduleSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 118);
/**
 * Describes the message grackle.ScheduleId.
 * Use `create(ScheduleIdSchema)` to create a new message.
 */
export const ScheduleIdSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 119);
/**
 * Describes the message grackle.ScheduleList.
 * Use `create(ScheduleListSchema)` to create a new message.
 */
export const ScheduleListSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 120);
/**
 * Describes the message grackle.CreateScheduleRequest.
 * Use `create(CreateScheduleRequestSchema)` to create a new message.
 */
export const CreateScheduleRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 121);
/**
 * Describes the message grackle.UpdateScheduleRequest.
 * Use `create(UpdateScheduleRequestSchema)` to create a new message.
 */
export const UpdateScheduleRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 122);
/**
 * Describes the message grackle.ListSchedulesRequest.
 * Use `create(ListSchedulesRequestSchema)` to create a new message.
 */
export const ListSchedulesRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 123);
/**
 * Describes the message grackle.CodespaceInfo.
 * Use `create(CodespaceInfoSchema)` to create a new message.
 */
export const CodespaceInfoSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 124);
/**
 * Describes the message grackle.CodespaceList.
 * Use `create(CodespaceListSchema)` to create a new message.
 */
export const CodespaceListSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 125);
/**
 * Describes the message grackle.ListCodespacesRequest.
 * Use `create(ListCodespacesRequestSchema)` to create a new message.
 */
export const ListCodespacesRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 126);
/**
 * Describes the message grackle.CreateCodespaceRequest.
 * Use `create(CreateCodespaceRequestSchema)` to create a new message.
 */
export const CreateCodespaceRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 127);
/**
 * Describes the message grackle.CreateCodespaceResponse.
 * Use `create(CreateCodespaceResponseSchema)` to create a new message.
 */
export const CreateCodespaceResponseSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 128);
/**
 * Describes the message grackle.DockerContainerInfo.
 * Use `create(DockerContainerInfoSchema)` to create a new message.
 */
export const DockerContainerInfoSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 129);
/**
 * Describes the message grackle.DockerContainerList.
 * Use `create(DockerContainerListSchema)` to create a new message.
 */
export const DockerContainerListSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 130);
/**
 * Describes the message grackle.ListDockerContainersRequest.
 * Use `create(ListDockerContainersRequestSchema)` to create a new message.
 */
export const ListDockerContainersRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 131);
/**
 * Describes the message grackle.GetSettingRequest.
 * Use `create(GetSettingRequestSchema)` to create a new message.
 */
export const GetSettingRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 132);
/**
 * Describes the message grackle.SetSettingRequest.
 * Use `create(SetSettingRequestSchema)` to create a new message.
 */
export const SetSettingRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 133);
/**
 * Describes the message grackle.SettingResponse.
 * Use `create(SettingResponseSchema)` to create a new message.
 */
export const SettingResponseSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 134);
/**
 * Describes the message grackle.PairingCodeResponse.
 * Use `create(PairingCodeResponseSchema)` to create a new message.
 */
export const PairingCodeResponseSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 135);
/**
 * Describes the message grackle.GetUsageRequest.
 * Use `create(GetUsageRequestSchema)` to create a new message.
 */
export const GetUsageRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 136);
/**
 * Describes the message grackle.UsageStats.
 * Use `create(UsageStatsSchema)` to create a new message.
 */
export const UsageStatsSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 137);
/**
 * Describes the message grackle.KnowledgeNodeProto.
 * Use `create(KnowledgeNodeProtoSchema)` to create a new message.
 */
export const KnowledgeNodeProtoSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 138);
/**
 * Describes the message grackle.KnowledgeEdgeProto.
 * Use `create(KnowledgeEdgeProtoSchema)` to create a new message.
 */
export const KnowledgeEdgeProtoSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 139);
/**
 * Describes the message grackle.SearchKnowledgeRequest.
 * Use `create(SearchKnowledgeRequestSchema)` to create a new message.
 */
export const SearchKnowledgeRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 140);
/**
 * Describes the message grackle.SearchKnowledgeResult.
 * Use `create(SearchKnowledgeResultSchema)` to create a new message.
 */
export const SearchKnowledgeResultSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 141);
/**
 * Describes the message grackle.SearchKnowledgeResponse.
 * Use `create(SearchKnowledgeResponseSchema)` to create a new message.
 */
export const SearchKnowledgeResponseSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 142);
/**
 * Describes the message grackle.GetKnowledgeNodeRequest.
 * Use `create(GetKnowledgeNodeRequestSchema)` to create a new message.
 */
export const GetKnowledgeNodeRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 143);
/**
 * Describes the message grackle.GetKnowledgeNodeResponse.
 * Use `create(GetKnowledgeNodeResponseSchema)` to create a new message.
 */
export const GetKnowledgeNodeResponseSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 144);
/**
 * Describes the message grackle.ExpandKnowledgeNodeRequest.
 * Use `create(ExpandKnowledgeNodeRequestSchema)` to create a new message.
 */
export const ExpandKnowledgeNodeRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 145);
/**
 * Describes the message grackle.ExpandKnowledgeNodeResponse.
 * Use `create(ExpandKnowledgeNodeResponseSchema)` to create a new message.
 */
export const ExpandKnowledgeNodeResponseSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 146);
/**
 * Describes the message grackle.ListRecentKnowledgeNodesRequest.
 * Use `create(ListRecentKnowledgeNodesRequestSchema)` to create a new message.
 */
export const ListRecentKnowledgeNodesRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 147);
/**
 * Describes the message grackle.ListRecentKnowledgeNodesResponse.
 * Use `create(ListRecentKnowledgeNodesResponseSchema)` to create a new message.
 */
export const ListRecentKnowledgeNodesResponseSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 148);
/**
 * Describes the message grackle.VersionStatus.
 * Use `create(VersionStatusSchema)` to create a new message.
 */
export const VersionStatusSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 149);
/**
 * Describes the message grackle.DomainEvent.
 * Use `create(DomainEventSchema)` to create a new message.
 */
export const DomainEventSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 150);
/**
 * Describes the message grackle.QueryDomainEventsRequest.
 * Use `create(QueryDomainEventsRequestSchema)` to create a new message.
 */
export const QueryDomainEventsRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 151);
/**
 * Describes the message grackle.DomainEventList.
 * Use `create(DomainEventListSchema)` to create a new message.
 */
export const DomainEventListSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 152);
/**
 * Describes the message grackle.StreamMessageEvent.
 * Use `create(StreamMessageEventSchema)` to create a new message.
 */
export const StreamMessageEventSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 153);
/**
 * Describes the message grackle.GetStreamTranscriptRequest.
 * Use `create(GetStreamTranscriptRequestSchema)` to create a new message.
 */
export const GetStreamTranscriptRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 154);
/**
 * Describes the message grackle.StreamTranscript.
 * Use `create(StreamTranscriptSchema)` to create a new message.
 */
export const StreamTranscriptSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 155);
/**
 * Describes the message grackle.SessionAction.
 * Use `create(SessionActionSchema)` to create a new message.
 */
export const SessionActionSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 156);
/**
 * Describes the message grackle.GetSessionActionsRequest.
 * Use `create(GetSessionActionsRequestSchema)` to create a new message.
 */
export const GetSessionActionsRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 157);
/**
 * Describes the message grackle.SessionActionList.
 * Use `create(SessionActionListSchema)` to create a new message.
 */
export const SessionActionListSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 158);
/**
 * Describes the message grackle.ServerEvent.
 * Use `create(ServerEventSchema)` to create a new message.
 */
export const ServerEventSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 159);
/**
 * Describes the message grackle.PluginInfo.
 * Use `create(PluginInfoSchema)` to create a new message.
 */
export const PluginInfoSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 160);
/**
 * Describes the message grackle.PluginList.
 * Use `create(PluginListSchema)` to create a new message.
 */
export const PluginListSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 161);
/**
 * Describes the message grackle.SetPluginEnabledRequest.
 * Use `create(SetPluginEnabledRequestSchema)` to create a new message.
 */
export const SetPluginEnabledRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 162);
/**
 * Describes the message grackle.ReadResourceRequest.
 * Use `create(ReadResourceRequestSchema)` to create a new message.
 */
export const ReadResourceRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 163);
/**
 * Describes the message grackle.ResourceContent.
 * Use `create(ResourceContentSchema)` to create a new message.
 */
export const ResourceContentSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 164);
/**
 * Describes the message grackle.ListResourceRequest.
 * Use `create(ListResourceRequestSchema)` to create a new message.
 */
export const ListResourceRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 165);
/**
 * Describes the message grackle.ResourceDirectoryEntry.
 * Use `create(ResourceDirectoryEntrySchema)` to create a new message.
 */
export const ResourceDirectoryEntrySchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 166);
/**
 * Describes the message grackle.ResourceListing.
 * Use `create(ResourceListingSchema)` to create a new message.
 */
export const ResourceListingSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 167);
/**
 * Describes the message grackle.WatchResourceRequest.
 * Use `create(WatchResourceRequestSchema)` to create a new message.
 */
export const WatchResourceRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 168);
/**
 * Describes the message grackle.WatchHandle.
 * Use `create(WatchHandleSchema)` to create a new message.
 */
export const WatchHandleSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 169);
/**
 * Describes the message grackle.UnwatchResourceRequest.
 * Use `create(UnwatchResourceRequestSchema)` to create a new message.
 */
export const UnwatchResourceRequestSchema = /*@__PURE__*/ messageDesc(file_grackle_grackle_types, 170);
/**
 * @generated from enum grackle.EventType
 */
export var EventType;
(function (EventType) {
    /**
     * @generated from enum value: EVENT_TYPE_UNSPECIFIED = 0;
     */
    EventType[EventType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: EVENT_TYPE_TEXT = 1;
     */
    EventType[EventType["TEXT"] = 1] = "TEXT";
    /**
     * @generated from enum value: EVENT_TYPE_TOOL_USE = 2;
     */
    EventType[EventType["TOOL_USE"] = 2] = "TOOL_USE";
    /**
     * @generated from enum value: EVENT_TYPE_TOOL_RESULT = 3;
     */
    EventType[EventType["TOOL_RESULT"] = 3] = "TOOL_RESULT";
    /**
     * @generated from enum value: EVENT_TYPE_ERROR = 4;
     */
    EventType[EventType["ERROR"] = 4] = "ERROR";
    /**
     * @generated from enum value: EVENT_TYPE_STATUS = 5;
     */
    EventType[EventType["STATUS"] = 5] = "STATUS";
    /**
     * @generated from enum value: EVENT_TYPE_SYSTEM = 6;
     */
    EventType[EventType["SYSTEM"] = 6] = "SYSTEM";
    /**
     * @generated from enum value: EVENT_TYPE_USER_INPUT = 9;
     */
    EventType[EventType["USER_INPUT"] = 9] = "USER_INPUT";
    /**
     * @generated from enum value: EVENT_TYPE_SIGNAL = 10;
     */
    EventType[EventType["SIGNAL"] = 10] = "SIGNAL";
    /**
     * @generated from enum value: EVENT_TYPE_USAGE = 11;
     */
    EventType[EventType["USAGE"] = 11] = "USAGE";
    /**
     * @generated from enum value: EVENT_TYPE_WIDGET = 13;
     */
    EventType[EventType["WIDGET"] = 13] = "WIDGET";
    /**
     * AHP HR2: a turn opened (content = the user message)
     *
     * @generated from enum value: EVENT_TYPE_TURN_STARTED = 14;
     */
    EventType[EventType["TURN_STARTED"] = 14] = "TURN_STARTED";
    /**
     * AHP HR2: a turn finished (session idle)
     *
     * @generated from enum value: EVENT_TYPE_TURN_COMPLETE = 15;
     */
    EventType[EventType["TURN_COMPLETE"] = 15] = "TURN_COMPLETE";
    /**
     * AHP HR2: turn blocked awaiting user input (plumb-only; no producer yet)
     *
     * @generated from enum value: EVENT_TYPE_INPUT_NEEDED = 16;
     */
    EventType[EventType["INPUT_NEEDED"] = 16] = "INPUT_NEEDED";
})(EventType || (EventType = {}));
/**
 * Describes the enum grackle.EventType.
 */
export const EventTypeSchema = /*@__PURE__*/ enumDesc(file_grackle_grackle_types, 0);
/**
 * @generated from enum grackle.TaskStatus
 */
export var TaskStatus;
(function (TaskStatus) {
    /**
     * @generated from enum value: TASK_STATUS_UNSPECIFIED = 0;
     */
    TaskStatus[TaskStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: TASK_STATUS_NOT_STARTED = 1;
     */
    TaskStatus[TaskStatus["NOT_STARTED"] = 1] = "NOT_STARTED";
    /**
     * @generated from enum value: TASK_STATUS_WORKING = 3;
     */
    TaskStatus[TaskStatus["WORKING"] = 3] = "WORKING";
    /**
     * @generated from enum value: TASK_STATUS_PAUSED = 4;
     */
    TaskStatus[TaskStatus["PAUSED"] = 4] = "PAUSED";
    /**
     * @generated from enum value: TASK_STATUS_COMPLETE = 5;
     */
    TaskStatus[TaskStatus["COMPLETE"] = 5] = "COMPLETE";
    /**
     * @generated from enum value: TASK_STATUS_FAILED = 6;
     */
    TaskStatus[TaskStatus["FAILED"] = 6] = "FAILED";
})(TaskStatus || (TaskStatus = {}));
/**
 * Describes the enum grackle.TaskStatus.
 */
export const TaskStatusSchema = /*@__PURE__*/ enumDesc(file_grackle_grackle_types, 1);
/**
 * @generated from enum grackle.WorkspaceStatus
 */
export var WorkspaceStatus;
(function (WorkspaceStatus) {
    /**
     * @generated from enum value: WORKSPACE_STATUS_UNSPECIFIED = 0;
     */
    WorkspaceStatus[WorkspaceStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: WORKSPACE_STATUS_ACTIVE = 1;
     */
    WorkspaceStatus[WorkspaceStatus["ACTIVE"] = 1] = "ACTIVE";
    /**
     * @generated from enum value: WORKSPACE_STATUS_ARCHIVED = 2;
     */
    WorkspaceStatus[WorkspaceStatus["ARCHIVED"] = 2] = "ARCHIVED";
})(WorkspaceStatus || (WorkspaceStatus = {}));
/**
 * Describes the enum grackle.WorkspaceStatus.
 */
export const WorkspaceStatusSchema = /*@__PURE__*/ enumDesc(file_grackle_grackle_types, 2);
/**
 * @generated from enum grackle.ClaudeProviderMode
 */
export var ClaudeProviderMode;
(function (ClaudeProviderMode) {
    /**
     * @generated from enum value: CLAUDE_PROVIDER_MODE_UNSPECIFIED = 0;
     */
    ClaudeProviderMode[ClaudeProviderMode["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: CLAUDE_PROVIDER_MODE_OFF = 1;
     */
    ClaudeProviderMode[ClaudeProviderMode["OFF"] = 1] = "OFF";
    /**
     * @generated from enum value: CLAUDE_PROVIDER_MODE_SUBSCRIPTION = 2;
     */
    ClaudeProviderMode[ClaudeProviderMode["SUBSCRIPTION"] = 2] = "SUBSCRIPTION";
    /**
     * @generated from enum value: CLAUDE_PROVIDER_MODE_API_KEY = 3;
     */
    ClaudeProviderMode[ClaudeProviderMode["API_KEY"] = 3] = "API_KEY";
})(ClaudeProviderMode || (ClaudeProviderMode = {}));
/**
 * Describes the enum grackle.ClaudeProviderMode.
 */
export const ClaudeProviderModeSchema = /*@__PURE__*/ enumDesc(file_grackle_grackle_types, 3);
/**
 * @generated from enum grackle.ProviderToggle
 */
export var ProviderToggle;
(function (ProviderToggle) {
    /**
     * @generated from enum value: PROVIDER_TOGGLE_UNSPECIFIED = 0;
     */
    ProviderToggle[ProviderToggle["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: PROVIDER_TOGGLE_OFF = 1;
     */
    ProviderToggle[ProviderToggle["OFF"] = 1] = "OFF";
    /**
     * @generated from enum value: PROVIDER_TOGGLE_ON = 2;
     */
    ProviderToggle[ProviderToggle["ON"] = 2] = "ON";
})(ProviderToggle || (ProviderToggle = {}));
/**
 * Describes the enum grackle.ProviderToggle.
 */
export const ProviderToggleSchema = /*@__PURE__*/ enumDesc(file_grackle_grackle_types, 4);
//# sourceMappingURL=grackle_types_pb.js.map